<template>
  <b-form autocomplete="off">
    <b-alert :show="isErrors" variant="danger">
      {{ translations[2016] }}
    </b-alert>
    <b-form-group class="mb-2" label-for="company-username">
      <b-form-input
        autocomplete="off"
        size="lg"
        class="border-0"
        id="company-username"
        v-model="login.username"
        type="text"
        :placeholder="translations[227]"
        required
      ></b-form-input>
    </b-form-group>
    <b-input-group class="mb-0" label-for="company-password">
      <b-form-input
        autocomplete="off"
        size="lg"
        class="border-0"
        id="company-password"
        v-model="login.password"
        :type="passwordFieldType"
        :placeholder="translations[228]"
        required
      ></b-form-input>
      <b-input-group-append>
        <b-button variant="custom-light"  @click="togglePasswordVisibility">
          <b-icon :icon="passwordFieldIcon"></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <p class="fs-6 m-0">
      <button type="button" v-b-modal.company-reset-password class="btn-inline-link text-aba-primary-800" @click="$emit('close')">{{ translations[10945] }}</button>
    </p>
  </b-form>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component
export default class LoginCompanyForm extends Vue {
  @Prop({ default: false }) private alpha!: boolean;

  isPasswordVisible = false;

  get translations() {
    return AppModule.translation;
  }

  get sid() {
    return AppModule.sid;
  }

  get lang() {
    return AppModule.language;
  }

  // TokenApplicant
  get accessTokenApplicant() {
    return UserModule.accessTokenApplicant;
  }

  // TokenConsultant
  get accessTokenConsultant() {
    return UserModule.accessTokenConsultant;
  }

  get isRedirectToCabinet() {
    return UserModule.isRedirectToCabinet;
  }

  get passwordFieldType() {
    return this.isPasswordVisible ? 'text' : 'password';
  }

  get passwordFieldIcon() {
    return this.isPasswordVisible ? 'eye-slash' : 'eye';
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  isErrors = false;

  login = {
    username: '',
    password: '',
    sid: this.sid,
  };

  async onLogin() {
    try {
      if (this.accessTokenConsultant) {
        UserModule.LogOutConsultant(this.sid);
      }

      if (this.accessTokenApplicant) {
        UserModule.LogOutApplicant(this.sid);
      }

      this.isErrors = false;

      await UserModule.LoginCompany(this.login).catch(() => {
        this.isErrors = true;
      });
      if (this.alpha) {
        UserModule.SetAlphaLogin('login-alpha');
      } else {
        UserModule.RemoveAlphaLogin();
      }

      this.login.username = '';
      this.login.password = '';
      if (this.isRedirectToCabinet) {
        await this.$router.push({
          name: 'Cabinet',
          query: { lang: this.lang },
        });
      } else {
        this.$emit('close');
      }
    } catch (error: any) {
      // this.$bvToast.toast(error.response.data.message, {
      //   title: 'Warning',
      //   variant: 'warning',
      //   autoHideDelay: 5000,
      //   solid: true,
      // });
    }
  }
}
</script>
